var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(" 总共收入: "+_vm._s(_vm.salary)+" 元 ")]),_c('div',{staticClass:"echart1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }